import { useState } from 'react'

import Action from "./Action"
import { HiOutlineCheck, HiOutlineX, HiOutlineExclamation } from "react-icons/hi"
import { HiMiniArrowUturnLeft } from "react-icons/hi2"

const icons = {
    success: HiOutlineCheck,
    failure: HiOutlineX,
    warning: HiOutlineExclamation
}

export default ({flash, lang}) => {
    const [flashingMessage, setFlashingMessage] = useState(null)
    flash.setCallback(setFlashingMessage)
    if (flashingMessage !== null) {
        const Icon = icons[flashingMessage.type]
        const iconComponent = Icon ? <span className="icon"><Icon /></span> : null
        const undoComponent = (flashingMessage.undoAction !== null) ? <Action action={flashingMessage.undoAction} title={lang.tr("undo")}><HiMiniArrowUturnLeft /></Action> : null
        return <div className="flash-box">
            <div className={"flash " + flashingMessage.type} onClick={() => flash.setNextMessage()}>
                {iconComponent} {flashingMessage.message} {undoComponent}
            </div>
        </div>
    }
    return <></>
}
